import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=116a852e&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=116a852e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a852e",
  null
  
)

export default component.exports